module.exports = {
    language: {
        name: 'English'
    },
    navMenu: {
        home: '首页',
        about: '关于展会',
        report: '学术报告会',
        service: '展会服务',
        download: '资料下载',
        contact: '联系我们',
    },
    home: {
        top: '回到顶部',
        more: '查看更多',
        latestNews: '最新动态',
        show: '企业展示',
        exciting: '精彩回顾',
        mediaPartners: '合作媒体',
        booth: '展位号',
        newsMore:'文章列表'
    },
}